exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".OpTableContentFilter .el-dialog__body{padding:10px}.OpTableContentFilter .relatedPersonnel{position:relative}.el-popover{padding:0}.el-popover .related-content{background:rgba(0,0,0,0.75);padding:10px}.el-popover .related-content p span{color:white;margin-left:15px}.el-popper[x-placement^=\"bottom\"] .popper__arrow::after{top:1px;margin-left:-6px;border-top-width:0;border-bottom-color:rgba(0,0,0,0.75)}.link-txt{color:#ff8850}\n", ""]);

// exports
